define('SageDotCom/Components/Videos/YoutubeVideo',[
    "jquery",
    "eventManager",
    "score_bootstrap/Components/YoutubeVideo",
    "youtube_api",
    "SageDotCom/DataLayer/Global/youtube-video-tracker"
],
    /**
     * Youtube documentation reference https://developers.google.com/youtube/iframe_api_reference
     * Pay attention amending this file Video Listing Component has relation of it 
     */
    function ($, eventManager, Youtube, ytApi, tracker) {
        function YoutubeVideo(scope, stateChangeMessages, onPlayMessagesPerformer, onPauseMessagePerformer, playInModal, guid) {
            if (window.youtubeTrackerTimeout) {
                clearTimeout(window.youtubeTrackerTimeout);
            }
            window.youtubeTrackerTimeout = setTimeout(new tracker().start, 250);   //Allow for iFrame to render

            //subscribes the event to change of the video state
            stateChangeMessages.push("onVideoChangeState:" + guid);
            eventManager.subscribe("onVideoChangeState:" + guid, function (obj) {
                //if video state == 2 means it's paused
                if (obj && obj.player && !playInModal && typeof obj.player.getPlayerState === "function") {
                    //video playing
                    $(".youtube-video-button", scope).fadeOut("fast");
                    $(".video-component", scope).fadeIn();
                }
            });

            //inheritance
            Youtube.call(this, scope, stateChangeMessages, onPlayMessagesPerformer, onPauseMessagePerformer);

            var $button = $(".youtube-video-button, lite-youtube", scope);
            var $modalVideo = $(".modal", scope);
            var $carousel = $button.parents(".carousel");
            var $carouselControls = $carousel.children(".carousel-control");
            var $carouselDots = $carousel.children(".carousel-indicators").children("li");

            //variable to detect when digital newsroom video card is present
            //First check if scope has an object with .parents defined to avoid errors
            var $isVideoCard = typeof scope.parents !== "undefined" ? scope.parents(".digital-newsroom-article").hasClass("video-card") : false;

            var youtubeComponent = this;

            function handleButtonClick() { 
                if (!$isVideoCard) {
                    $(".youtube-video-button", scope).fadeOut("fast");
                }

                if (playInModal && $isVideoCard) {
                    //Workaround for issue with modal displaying in card, need to disable transform before showing modal
                    scope.parents(".video-card").addClass("disable-hover");
                    setTimeout(function () {
                        $modalVideo.modal("show");
                        youtubeComponent.play();
                    }, 250);
                } else if (playInModal) {

                    var $carouselInner = $carousel.children(".carousel-inner");

                    if ($carouselInner) {
                        $carouselInner.addClass("carousel-inner-disabled");
                        $carouselInner.removeClass("carousel-inner");
                    }

                    if ($modalVideo.closest(".slick-track").length > 0) {
                        setTimeout(function () {
                            //fix for modal in the slick slider
                            $modalVideo.closest(".slick-track").addClass("slick-track-disabled").removeClass("slick-track");
                            $modalVideo.closest(".slick-list").addClass("slick-list-disabled").removeClass("slick-list");
                        }, 0);
                    }

                    //plays in modal calling bootstrap modal show
                    $modalVideo.modal("show");
                } else {
                    // the inline video component is hidden by default, to play the video, we should make it visible first 
                    $(".video-component", scope).fadeIn("fast");
                }

                $carousel.carousel("pause");

                // plays the youtube video
                youtubeComponent.play();
            }

            function pauseThisVideo() {
                try {
                    youtubeComponent.pause();
                }
                catch (error) {
                    console.error(error);
                }

                if (!(youtubeComponent.player && typeof youtubeComponent.player.pauseVideo === "function")) {
                    //Fix for when player doesn't have pause functionality
                    $modalVideo.find("iframe")[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }
            }

            setTimeout(function () {
                // Attach the function to the button click event
                $button.on("click", function (e) {
                    e.preventDefault();

                    // Call the function on button click
                    handleButtonClick();
                });

                // Call the function immediately to execute the logic the first time
                handleButtonClick();

                $carouselControls.add($carouselDots).on("click", function (e) {
                    //Carousel controls clicked, pause the video
                    pauseThisVideo();
                });

                $modalVideo.on("hidden.bs.modal", function (e) {
                    if ($isVideoCard) {
                        scope.parents(".video-card").removeClass("disable-hover");
                    }

                    var $carouselInnerDisabled = $carousel.children(".carousel-inner-disabled");
                    if ($carouselInnerDisabled) {
                        $carouselInnerDisabled.addClass("carousel-inner");
                        $carouselInnerDisabled.removeClass("carousel-inner-disabled");
                    }

                    //modal has been closed. Pauses the video and show the player image
                    pauseThisVideo();
                    $(".youtube-video-button", scope).fadeIn();

                    setTimeout(function () {
                        //fix for modal in the slick slider
                        $(".youtube-video-button", scope).closest(".slick-track-disabled").addClass("slick-track").removeClass("slick-track-disabled");
                        $(".youtube-video-button", scope).closest(".slick-list-disabled").addClass("slick-list").removeClass("slick-list-disabled");
                    }, 0);
                });

                $(".modal-header .close", scope).click(function () {
                    // pause the video if it is closed so it doesn't keep playing
                    pauseThisVideo();

                    $(".youtube-video-button", scope).fadeIn();
                });
            }, 250);
        }

        YoutubeVideo.prototype = Object.create(Youtube.prototype);

        YoutubeVideo.init = function (args) {
            if (ytApi && "error_sage_fallback" in ytApi) {
                console && console.info && console.info("YoutubeVideo component could not load youtube api");
                return null;
            }

            if (args === void 0 || args === null || args.IsExperienceEditorEditing)
                return null;
            else
                return new YoutubeVideo(args.scope,
                    args.stateChange || [],
                    args.playMessage || [],
                    args.pauseMessage || [],
                    args.playInModal || false,
                    args.guid);
        };

        return YoutubeVideo;
    });
